import axiosAuth from '../../axiosMain';

async function store(data) {
  let response = await axiosAuth.post('/certification_questions', data);
  return response.data.data;
}

export default {
  store,
};
